<template>
  <div id="app">
    <b-navbar type="dark" variant="dark" sticky>
      <b-navbar-brand href="#" variant="light">
        TERA Farmer
      </b-navbar-brand>
      <b-navbar-nav class="ml-auto">
        <!-- <b-button class="mr-2" @click="openCite" variant="success">Cite</b-button> -->
        <!--<b-button class="mr-2" @click="openHelp" variant="info">Help</b-button>-->
        <b-button class="mr-2" variant="danger" @click="newIds = []">
          Clear
        </b-button>
        <b-button id="tooltip-help" style="border-radius: 20px; width: 90px; margin-left: 6px; background-color: #21a5d5;" class="btn btn-info" @click="openHelp">Help</b-button>
				<b-tooltip style="width:400px !important;" target="tooltip-help" triggers="hover" placement="bottom">
							<h6>Click here to see help page</h6>
				</b-tooltip>
      </b-navbar-nav>
    </b-navbar>

    <b-container>
      <!-- LOGO -->
      <b-row>
        <b-col>
          <div class="logo">
            <i class="fas fa-tractor fa-style mr-2 mt-4" />
            <!-- <img style="width: 195px; height: 150px;" src="./assets/Tractor.png" alt="Custom Image"> -->
            <!-- <b-icon style="width: 150px; height: 150px;" icon="newspaper"></b-icon> -->
            <h2>TERA Farmer</h2>
          </div>
        </b-col>
      </b-row>

      <!-- Input for pubmed IDs -->
      <b-row>
        <b-col class="mt-2" style="max-width: 600px; margin: auto">
          <FileUpload @getPmids="getPmids" />
          
          <p class="mt-3">OR</p>
          <b-form-group
            description="`Enter Pubmed ID of Article/s to Find Relevant Papers (press enter or space after each ID is entered). 
            Using a list of Pubmed IDs, related articles can be searched (e.g. 25435309). IDs must be numerical with no duplicates.`"
            label-for="pubmed-id"
          >
            <b-form-tags
              input-id="tags-separators"
              separator=" ,"
              v-model="newIds"
              validate="digits"
              :add-tag-on-keys="[32, 13, 188, 9]"
              class="my-4"
            />
          </b-form-group>
          <!-- <b-form-group
            description="Using a list of Pubmed IDs, related articles can be searched (e.g. 25435309). IDs must be numerical with no duplicates."
            label="Enter Pubmed ID of Article/s to Find Relevant Papers (press enter or space after each ID is entered)"
            label-for="pubmed-id"
          >
            <b-form-tags
              input-id="tags-separators"
              separator=" ,"
              v-model="newIds"
              validate="digits"
              :add-tag-on-keys="[32, 13, 188, 9]"
              class="my-4"
            />
          </b-form-group> -->
        </b-col>
      </b-row>

      <!-- Display the papers used in the search in a table -->
      <b-row>
        <b-col class="px-4">
          <div v-if="searchPapers">
            <h3>Papers used in search</h3>
            <b-table
              class="m-2"
              style="text-align: left; background-color: white;"
              striped
              bordered
              :items="searchPapers"
              :fields="searchFields"
            >
              <template v-slot:cell(title)="data">
                <a
                  v-bind:href="
                    'https://pubmed.ncbi.nlm.nih.gov/' + data.value.pmid
                  "
                  target="_blank"
                  >{{ data.value.title }}</a
                >
              </template>
              <template v-slot:cell(authors)="data">
                {{ formatArray(data.value) }}
              </template>
            </b-table>
          </div>
          <b-spinner v-else-if="isLoadingSearch"></b-spinner>
        </b-col>
      </b-row>

      <!-- Search Button -->
      <b-row>
        <b-col>
          <b-button-group>
            <b-button v-on:click="submit">Find Related</b-button>
            <!-- <b-button v-b-modal.options variant="dark">
              <b-icon icon="gear-fill"></b-icon>
            </b-button> -->
          </b-button-group>
        </b-col>
      </b-row>

      <!-- Display related papers in table with download button -->
      <b-row>
        <b-col class="p-4">
          <div v-if="relevantPapers">
            <h3>Related Articles</h3>
            <b-button v-on:click="download">
              Save
            </b-button>
            <!--<b-button variant="info" v-on:click="showAllRef = !showAllRef">
              ShowAllRelatedPapers: {{ allRefNum }}
            </b-button>-->
            <b-form-checkbox name="check-button" v-model="showAllRef" switch
              >Show All Related Papers: {{ allRefNum }}</b-form-checkbox
            >

            <div v-if="showAllRef == false">
              <b-table
                class="m-2"
                style="text-align: left; background-color: white;"
                striped
                bordered
                :items="relevantPapers"
                :fields="relatedFields"
              >
                <template v-slot:cell(title)="data">
                  {{ data.value.title }}
                </template>
                <template v-slot:cell(authors)="data">
                  {{ formatArray(data.value) }}
                </template>
              </b-table>
            </div>
            <div v-if="showAllRef == true">
              <b-pagination
                v-model="currentPage"
                :total-rows="allRelatedPapers.length"
                :per-page="perPage"
                aria-controls="refTable"
              ></b-pagination>
              <b-table
                id="refTable"
                class="m-2"
                style="text-align: left;background-color: white;"
                striped
                bordered
                :per-page="perPage"
                :current-page="currentPage"
                :items="allRelatedPapers"
                :fields="relatedFields"
              >
                <template v-slot:cell(title)="data">
                  {{ data.value.title }}
                </template>
                <template v-slot:cell(authors)="data">
                  {{ formatArray(data.value) }}
                </template>
              </b-table>
            </div>
          </div>
          <b-spinner v-else-if="isLoading"></b-spinner>
          <!-- <template>
            <hr class="d-none d-md-flex" />
          </template> -->
          <!-- <div
            class="d-none d-md-flex alert alert-info row mt-4 small p-2"
            style="max-width: 600px; margin: auto;"
          >
            <div class="col-8">
              <p class="mb-2">
                You can also jump to TERA Farmer directly from a Pubmed article.
              </p>
              <p class="mb-0">
                Drag the button to the right to your bookmarks bar and click it
                when viewing a Pubmed article to immediately search against that
                article
              </p>
            </div>
            <div class="col-4 d-flex align-items-center justify-content-center">
              <a
                class="btn btn-secondary btn-sm d-flex align-items-center btn-draggable"
                href="javascript: var bkmk=document.createElement('script'); bkmk.type = 'text/javascript'; bkmk.src = 'https://terafarmer.tera-tools.com/BookMark.js'; document.head.appendChild(bkmk);"
              >
                <b-icon icon="bookmark" aria-hidden="true" class="mr-1" />
                TERA-Farm this!
              </a>
              <b-popover target="bkmk_button" triggers="hover" placement="top">
                <template #title
                  >Drag this button to your bookmark bar</template
                >
              </b-popover>
            </div>
          </div> -->
        </b-col>
      </b-row>
    </b-container>
    <b-modal id="options">
      <OptionsModal :options="options"></OptionsModal>
    </b-modal>
  </div>
</template>

<script>
import { Component, Vue, Watch } from "vue-property-decorator";
import OptionsModal from "./components/OptionsModal.vue";
import FileUpload from "./components/FileUpload.vue";
import { Ref, DefaultOptions } from "./types";
//import InputTag from "vue-input-tag";
import axios from "axios";
const parseString = require("xml2js").parseString;
import _ from "lodash";

@Component({
  components: {
    OptionsModal,
    FileUpload,
  },
})
export default class App extends Vue {
  //@Watch("ids")

  @Watch("newIds")
  onIdsChanged() {
    console.log("newIds:" + this.newIds);
    this.getSearchInfo();
  }

  showAllRef = false;
  allRefNum = 0;
  allRelatedPapers = null;
  currentPage = 1;
  perPage = 50;
  urlids = 0;
  //private ids: Array<string> = [];
  newIds = [];
  scores = [];
  relevantPapers = null;
  searchPapers = null;

  searchFields = [
    {
      key: "year",
      sortable: true,
    },
    {
      key: "title",
      sortable: true,
    },
    {
      key: "authors",
      sortable: true,
    },
  ];

  relatedFields = [
    {
      key: "year",
      sortable: true,
    },
    {
      key: "title",
      sortable: true,
    },
    {
      key: "authors",
      sortable: true,
    },
    {
      key: "notes",
      sortable: true,
    },
  ];
  isLoading = false;
  isLoadingSearch = false;
  options = new DefaultOptions();

  mounted() {
    this.urlids = new URL(window.location.href);
    if (this.urlids.searchParams.get("PMid") != null) {
      this.newIds = this.urlids.searchParams.get("PMid").split(",");
    } else {
      console.log("PMID:" + this.urlids.searchParams.get("id"));
      //Get PubmedID from URL and search it directly
      if (this.urlids.searchParams.get("id") != null) {
        this.newIds.push(this.urlids.searchParams.get("id"));
      }
    }
  }
  //Get PubmedIDs from uploaded xml file
  getPmids(data) {
    if (data) {
      /*const das: Array<any> = [];
      for (let i = 0; i < data.length; i++) {
        das.push(data[i][0]);
      }
      this.newIds = das;*/
      this.newIds = data;
    }
  }
  formatArray(arr) {
    let string = "";
    if (arr.length > 0) {
      for (let i = 0; i < arr.length - 1; i++) {
        string = string.concat(arr[i] + ", ");
      }
      string = string.concat(arr[arr.length - 1]);
    }
    return string;
  }
  openHelp() {
    // Open help page
    window.open("https://tera-tools.com/help/terafarmer", "_blank");
  }

  async getRequest(url) {
    return axios
      .get(url)
      .then((res) => res.data)
      .catch((err) => err);
  }

  async parseXML(xml) {
    return new Promise((resolve, reject) => {
      parseString(xml, { explicitArray: false }, (err, result) => {
        if (err) {
          reject(err);
        } else {
          resolve(result);
        }
      });
    });
  }

  async getRelatedID(idString) {
    const ids = [];
    const searchString =
      "https://eutils.ncbi.nlm.nih.gov/entrez/eutils/elink.fcgi?LinkName=pubmed_pubmed&id=" +
      idString +
      "&cmd=neighbor_score";

    // Query entrez to get XML with article IDs
    const related = await this.getRequest(searchString);
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(related, "text/xml");
    // Find full list of article ID and score
    const articles = xmlDoc.getElementsByTagName("Link");
    for (const article of articles) {
      const id = article.getElementsByTagName("Id")[0].firstChild?.nodeValue;
      const score = article.getElementsByTagName("Score")[0].firstChild
        ?.nodeValue;
      if (id && score) {
        this.scores.push({ id, score });
      }
      ids.push(id);
    }
    return ids;
  }

  async getArticleInfo(relatedString) {
    const searchString =
      "https://eutils.ncbi.nlm.nih.gov/entrez/eutils/efetch.fcgi?db=pubmed&id=" +
      relatedString +
      "&retmode=xml";
    const response = await this.getRequest(searchString);
    const result = await this.parseXML(response);

    if (result.PubmedArticleSet) {
      // Check if there is one or multiple articles in the set and act accordingly
      let articles;
      if (_.isArray(result.PubmedArticleSet.PubmedArticle)) {
        articles = result.PubmedArticleSet.PubmedArticle.map((article) => {
          return article.MedlineCitation;
        });
      } else {
        articles = result.PubmedArticleSet.PubmedArticle.MedlineCitation;
      }

      articles = _.cloneDeepWith(articles, (v, k) =>
        _.isString(v) || _.isArray(v) ? undefined : v._
      );
      return articles;
    } else {
      return null;
    }
  }

  async getArticleSummary(idString) {
    const searchString =
      "https://eutils.ncbi.nlm.nih.gov/entrez/eutils/esummary.fcgi?db=pubmed&id=" +
      idString;
    const response = await this.getRequest(searchString);
    const result = await this.parseXML(response);
    return result;
  }

  mapToReflib(articleInfo, i) {
    // If articleInfo is not array make it one
    if (!_.isArray(articleInfo)) articleInfo = [articleInfo];
    const refs = [];
    //let i = 0;
    for (const a of articleInfo) {
      const ref = {};
      // Map article title
      ref.title = {
        title: _.get(a, "Article.ArticleTitle", "N.A."),
        pmid: _.get(a, "PMID", "N.A."),
      };
      // Map year
      ref.year = _.get(
        a,
        "Article.ArticleDate.Year",
        _.get(a, "DateCompleted.Year", "N.A.")
      );
      // Map authors
      let authors = _.get(a, "Article.AuthorList.Author", []);
      // Ensure that it is an array
      authors = [].concat(authors);
      // Map values to standard format
      ref.authors = authors.map((author) => {
        return author.Initials + "." + author.LastName;
      });
      ref.notes = "Relevance " + ++i;
      //Map Abstract
      ref.abstract = _.get(a, "Article.Abstract.AbstractText", "N.A.");
      //Map Pagination
      ref.pages = _.get(a, "Article.Pagination", "N.A.");

      refs.push(ref);
    }
    return refs;
  }

  async getSearchInfo() {
    //if (this.ids.length === 0) return (this.searchPapers = null);
    if (this.newIds.length === 0) return (this.searchPapers = null);
    this.isLoadingSearch = true;
    this.searchPapers = null;
    //const idString = this.ids.toString();
    const idString = this.newIds.toString();
    const searchInfo = await this.getArticleInfo(idString);
    this.searchPapers = searchInfo ? this.mapToReflib(searchInfo, 0) : null;
    //console.log("searchPapers:"+JSON.stringify(this.searchPapers));//output info after format of mapToReflib
    this.isLoadingSearch = false;
  }
  async submit() {
    this.isLoading = true;
    this.relevantPapers = null;
    // Convert list of IDs to string seperated by commas
    //const idString = this.ids.toString();
    const idString = this.newIds.toString();
    // Get a list of related article IDs
    const ids = await this.getRelatedID(idString);
    // Convert returned ID to string to allow query for full articles
    const relatedString = ids.slice(0, 50).toString();
    // Get the article info of all related articles
    const articleInfo = await this.getArticleInfo(relatedString);
    this.relevantPapers = articleInfo ? this.mapToReflib(articleInfo, 0) : null;
    if (this.relevantPapers != null) {
      //solve url too long
      this.allRelatedPapers = null;
      this.allRefNum = ids.length;
      let j = 0;
      for (let i = 0; i < ids.length - 50; i += 50) {
        j = i + 49;
        const reString = ids.slice(i, j).toString();
        const reArticleInfo = await this.getArticleInfo(reString);
        const rePapers = reArticleInfo
          ? this.mapToReflib(reArticleInfo, i)
          : null;
        if (rePapers != null) {
          if (this.allRelatedPapers != null) {
            this.allRelatedPapers = this.allRelatedPapers.concat(rePapers);
          } else {
            this.allRelatedPapers = rePapers;
          }
        }
      }
      if (j < ids.length) {
        const reString = ids.slice(j, ids.length).toString();
        const reArticleInfo = await this.getArticleInfo(reString);
        const rePapers = reArticleInfo
          ? this.mapToReflib(reArticleInfo, j)
          : null;
        if (rePapers != null) {
          if (this.allRelatedPapers != null) {
            this.allRelatedPapers = this.allRelatedPapers.concat(rePapers);
          } else {
            this.allRelatedPapers = rePapers;
          }
        }
      }
    }
    this.isLoading = false;
  }

  download() {
    if (this.relevantPapers && this.showAllRef == false) {
      this.relevantPapers.forEach((data) => {
        data.title = data.title.title;
      });
      return this.$tera.setProjectLibrary(this.relevantPapers, {
        filename: "farmed",
      });
    }
    if (this.allRelatedPapers && this.showAllRef == true) {
      this.allRelatedPapers.forEach((data) => {
        data.title = data.title.title;
      });
      return this.$tera.setProjectLibrary(this.allRelatedPapers, {
        filename: "farmed-related",
      });
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
  background-color: #dee2e6;
}
body{
  background-color: #dee2e6 !important;
}

.logo {
  color: #008037;
}

#combine-arrow {
  margin-right: 10em;
  margin-left: 10em;
  border: 8px solid #2c3e50;
  border-style: hidden solid solid solid;
  border-radius: 0px 0px 20px 20px;
  width: 100%;
  height: 100px;
}

#down-arrow {
  width: 100px;
  height: 100px;
  color: #2c3e50;
  margin-top: -20px;
}

.name-input {
  padding: 10px 10px 10px 10px;
}

.btn-draggable {
  cursor: grab !important;
}

.fa-style {
  font-size: 10.25em;
  line-height: 1.05em;
  vertical-align: -0.075em;
}

/* width */
::-webkit-scrollbar {
  width: 15px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey;
  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  /* background: #536fab;  */
  background: #7f8daf;
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #536fab;
}
.navbar {
  background-image: linear-gradient(#6880b5, #465b8b, #5971a5);
  color: #dcdee5;
}
</style>
